import React, {Component} from 'react';
import {connect} from 'react-redux';
import {redirectToDataRegistration} from '../../ducks/Navigate';
import {RouteKeys} from '../../constants';
import {StringService} from '../../services';

import './styles.scss';

class InitialRegistration extends Component {
  constructor(props) {
    super(props);
    document.title = StringService.formatTitle(
      RouteKeys.InitialRegistration.title,
    );
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit = (event) => {
    event.preventDefault();

    this.props.redirectToDataRegistration();
  };

  render = () => (
    <div className="div-initial-registration">
      <div className="header-background">
        <div className="header">
          <div className="done">
            <div className="icon-check">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.76 51.4">
                <g id="Layer_2" data-name="Layer 2">
                  <g id="Header">
                    <path
                      className="cls-1"
                      d="M21.51,51.4A4.83,4.83,0,0,1,18.13,50L1.4,33.26A4.78,4.78,0,1,1,8.16,26.5l13,13L51.25,1.79a4.78,4.78,0,0,1,7.46,6L25.24,49.6a4.77,4.77,0,0,1-3.47,1.79Z"
                    />
                  </g>
                </g>
              </svg>
            </div>
            <p className="text"> Pronto </p>
          </div>
        </div>
      </div>
      <div className="content">
        <div className="title">
          <p>Seja Bem-vindo</p>
        </div>
        <div className="instruction-info">
          Pegue seu RG ou CNH e vamos começar!
        </div>
        <div className="info">
          <small>* Sujeito à análise de crédito.</small>
        </div>
        <div className="button-container-flex">
          <div className="button-container">
            <button className="button" onClick={this.handleSubmit}>
              Continuar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = () => {
  return {};
};

export default connect(mapStateToProps, {redirectToDataRegistration})(
  InitialRegistration,
);
